import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import Divider from 'app/components/bibs/shared/Divider';
import { ExpandableText } from '@bibliocommons/expandable';
import { catalogBibShape, ugcQuotationShape, paginationShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import QuotationDisplayContainer from 'app/components/bibs/shared/ugc/QuotationDisplay';
import { ContentWarningPanelContainer } from 'app/components/bibs/shared/ugc/ContentWarningPanel';
import { QuotationEditorContainer } from 'app/components/bibs/shared/ugc/QuotationEditor';
import UgcList from 'app/components/bibs/shared/ugc/UgcList';
import BibSubPage from 'app/components/bibs/subpages/BibSubPage';
import './AllQuotationsPage.scss';

export class AllQuotationsPage extends React.PureComponent {
  componentDidMount() {
    this.fetchRelationships();
  }

  componentDidUpdate(prevProps) {
    if (!this.props.userIds.equals(prevProps.userIds)) {
      this.fetchRelationships();
    }
  }

  fetchRelationships() {
    const { currentUser, relationshipsActions, userIds } = this.props;
    const currentUserId = currentUser?.get('id');

    if (currentUserId && userIds.size) {
      relationshipsActions.getRelationships({ userId: currentUserId, userIds });
    }
  }

  handleSuccess = () => {
    const metadataId = this.props.catalogBib.get('metadataId');
    this.props.quotationsActions.getQuotations({ metadataId });
  };

  renderQuotation = quotation => {
    return (
      <QuotationDisplayContainer
        quotation={quotation}
        key={quotation.get('id')}
        catalogBib={this.props.catalogBib}
        handleDeleteSuccess={this.handleSuccess}
      >
        <ExpandableText
          text={quotation.get('quotation')}
          truncateCount={240}
          expandLinkHref={`#read-more-ugc-display-${quotation.get('id')}`}
          textKey="quotation"
        />
      </QuotationDisplayContainer>
    );
  };

  renderEditor = () => {
    const { catalogBib, ugcEditorActions } = this.props;

    return (
      <QuotationEditorContainer
        catalogBib={catalogBib}
        handleCancel={() => ugcEditorActions.closeEditor('quotation')}
        handleSuccess={this.handleSuccess}
      />
    );
  };

  render() {
    const { catalogBib, quotations, quotationsTransactions, pagination, isFetching } = this.props;

    return (
      <div className="cp-all-quotations-page">
        <BibSubPage catalogBib={catalogBib} headerLocKey="quotations" pagination={pagination} isFetching={isFetching}>
          <UgcList
            items={quotations}
            pagination={pagination}
            catalogBib={catalogBib}
            transactions={quotationsTransactions}
            renderItem={this.renderQuotation}
            renderEditor={this.renderEditor}
            contentType="community_comments"
            ugcType="quotations"
            showDisclaimer
          >
            <Divider />
            <ContentWarningPanelContainer />
          </UgcList>
        </BibSubPage>
      </div>
    );
  }
}

AllQuotationsPage.propTypes = {
  catalogBib: catalogBibShape.isRequired,
  currentUser: userIdentityShape,
  quotations: ImmutablePropTypes.listOf(ugcQuotationShape).isRequired,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  pagination: paginationShape.isRequired,
  ugcEditorActions: PropTypes.objectOf(PropTypes.func).isRequired,
  quotationsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  isFetching: PropTypes.bool,
  relationshipsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  userIds: ImmutablePropTypes.listOf(PropTypes.number).isRequired
};

export default AllQuotationsPage;
